<template>
    <div class="">
        <text-clamp
            autoResize
            :max-lines="previewLines"
            :text="text"
            :expanded="showAll"
            location="end"
        >
            <template #after>
                <span v-if="!showAll" @click="toggleShowAll"
                    >...
                    <span
                        class="text-gray-600 hover:cursor-pointer hover:text-gray-900 hover:underline"
                        >Read more</span
                    ></span
                >
            </template>
        </text-clamp>
    </div>
</template>
<script>
export default {
    name: "read-more-text-block",
    props: {
        text: {
            type: String,
            default: "",
        },
        previewLines: {
            type: Number,
            default: 3,
        },
    },
    data() {
        return {
            showAll: false,
        };
    },
    methods: {
        toggleShowAll() {
            this.showAll = !this.showAll;
        },
    },
};
</script>
